class ToolbarSearch extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector(".toolbar-search__toggle");
    this.panel = this.querySelector(".toolbar-search__panel");
    this.input = this.querySelector(".toolbar-search-field__input");
    this.form = this.querySelector("form");

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  connectedCallback() {
    this.toggle?.addEventListener("click", this.onToggleClick);
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeyDown);
    this.form?.addEventListener("submit", this.onFormSubmit);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener("click", this.onToggleClick);
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeyDown);
    this.form?.removeEventListener("submit", this.onFormSubmit);
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.classList.contains("is-open")) {
      this.close();
      return;
    }

    document.querySelectorAll("toolbar-search.is-open").forEach((element) => {
      if (element !== this) element.close();
    });

    this.open();
  }

  onDocumentClick(event) {
    if (!this.classList.contains("is-open")) return;
    if (this.contains(event.target)) return;
    this.close();
  }

  onKeyDown(event) {
    if (!this.classList.contains("is-open")) return;
    if (event.key === "Escape") {
      this.close();
    }
  }

  onFormSubmit(event) {
    const query = this.input?.value.trim();
    if (!query) {
      event.preventDefault();
      this.input?.focus();
    }
  }

  open() {
    if (!this.panel || !this.toggle) return;

    this.classList.add("is-open");
    this.panel.setAttribute("aria-hidden", "false");
    this.toggle.setAttribute("aria-expanded", "true");

    window.requestAnimationFrame(() => {
      this.input?.focus();
    });
  }

  close() {
    if (!this.panel || !this.toggle) return;

    this.classList.remove("is-open");
    this.panel.setAttribute("aria-hidden", "true");
    this.toggle.setAttribute("aria-expanded", "false");
    this.toggle.focus();
  }
}

if (!customElements.get("toolbar-search")) {
  customElements.define("toolbar-search", ToolbarSearch);
}
